import { apiClient } from '../api';
import { Path } from '../api/backendUrl';

export const getUserById = async (id: string) => {
  try {
    const res = await apiClient.get(
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.getUserById}`.replace(
        ':id',
        id
      )
    );
    return res.data;
  } catch (error: unknown) {
    console.log('ERROR getUserById: ', error);
    throw error;
  }
};

// Persist a user's phone number (E.164). Reuses the generic user-update
// endpoint, which also syncs phone_number to Cognito server-side.
export const updateUserMobile = async (
  userId: string,
  mobile: string,
  role: string,
  email: string
) => {
  try {
    const res = await apiClient.put(
      `${import.meta.env.VITE_APP_BACKEND_USER}/user/${userId}`,
      { mobile, email: email, groupRole: role }
    );

    return res.data;
  } catch (error: unknown) {
    console.log('ERROR updateUserMobile: ', error);
    throw error;
  }
};

export const addUserAddress = async (id: string, data: any) => {
  try {
    const res = await apiClient.post(
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.addUserAddress}`.replace(
        ':id',
        id
      ),
      data
    );
    return res.data;
  } catch (error: unknown) {
    console.log('ERROR add new: ', error);
    throw error;
  }
};

export const removeUserAddress = async (id: string, addressId: string) => {
  console.log('id: ', id, 'addressId: ', addressId);
  try {
    const res = await apiClient.delete(
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.removeUserAddress}`
        .replace(':id', id)
        .replace(':addressId', addressId)
    );
    return res.data;
  } catch (error: unknown) {
    console.log('ERROR remove address: ', error);
    throw error;
  }
};

export const updateUserAddress = async (
  id: string,
  data: any,
  addressId: string
) => {
  try {
    const res = await apiClient.put(
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.removeUserAddress}`
        .replace(':id', id)
        .replace(':addressId', addressId),
      data
    );
    return res.data;
  } catch (error: unknown) {
    console.log('ERROR update address: ', error);
    throw error;
  }
};

export const becomeAProvider = async (
  id: string,
  membershipPlanName?: string,
  businessId?: string
) => {
  try {
    const res = await apiClient.put(
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.becomaAProvider}`.replace(
        ':id',
        id
      ),
      {
        membershipType: membershipPlanName || 'free',
        ...(businessId ? { businessId } : {}),
      }
    );
    return res.data;
  } catch (error: unknown) {
    console.log('ERROR Become a provider:  ', error);
    throw error;
  }
};
